import { getSaleStatusTag } from "../../extensions/helper";
import { fmtDate, frmSymaNull } from "../../extensions/utils";

const VisitClientAbonItem = ({ item, onSelect, selected }) => {
  return<div className="visit-client-abon-item" onClick={() => onSelect(item)}>
    <div className={`visit-client-abon-item-indicator ${selected ? " visit-client-abon-item-indicator-selected" : ""}`}><div /></div>
    <div className="visit-client-abon-item-body">
      <div className="visit-client-abon-item-line1">
        <div># {item.id}</div>
        <div className="vitis-item-clip">{item.productName}</div>
      </div>
      <div className="visit-client-abon-item-line2">
        <div>{getSaleStatusTag(item.status)}</div>
        <div>{item.finish ? `до ${fmtDate(item.finish)}` : ""}</div>
        <div className="visit-client-abon-debet">{item.debet ? `Долг ${frmSymaNull(item.debet)}` : ""}</div>
      </div>
    </div>
  </div>
}

export default VisitClientAbonItem;